<template>
  <el-dialog
    v-dialogDrag
    :append-to-body="true"
    :visible.sync="currentItemProps.visible"
    :lock-scroll="false"
    title="编辑任务"
  >
    <el-form :model="modelForm" :rules="modelFormRules" ref="modelFormRef" label-width="150px">
      <el-form-item label="任务编码" prop="code">
        <el-input v-model="modelForm.code" placeholder="请输入任务编码" size="small" clearable />
      </el-form-item>
      <el-form-item label="任务名称" prop="name">
        <el-input v-model="modelForm.name" placeholder="请输入作业名称" size="small" clearable />
      </el-form-item>

      <el-form-item label="工期(工日)" prop="actualSchedule">
        <el-input-number
          class="w-full"
          v-model="modelForm.actualSchedule"
          :min="0"
        ></el-input-number
      ></el-form-item>
      <el-form-item label="预计任务期限" prop="dateRange">
        <el-date-picker
          class="w-full"
          v-model="dateRange"
          type="daterange"
          :clearable="false"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          end-placeholder="结束日期"
          placeholder="选择计划开始时间"
          @change="dateChange"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="里程碑" prop="isMilestone">
        <el-radio-group v-model="modelForm.isMilestone">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="前置节点" prop="prePlanTaskId">
        <el-select
          v-model="modelForm.prePlanTaskId"
          class="w-full"
          :remote-method="remoteMethod"
          :loading="loading"
          filterable
          remote
          reserve-keyword
        >
          <el-option
            v-for="item in scheduleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入备注"
          v-model="modelForm.remark"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="submit()">保存</el-button>
      <el-button size="small" @click="close()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { PlanTaskApi } from '@wiz-api/construction-schedule-management'

const planTaskApi = new PlanTaskApi()
export default {
  props: {
    currentItemProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      dateRange: [],
      modelForm: { dateRange: [] },
      modelFormRules: {
        code: [
          {
            required: true,
            message: '任务编码必填',
          },
        ],

        name: [
          {
            required: true,
            message: '预计任务期限必填',
          },
        ],

        dateRange: [
          {
            required: true,
            message: '计划开始时间',
          },
        ],
      },
      scheduleList: [],
    }
  },
  methods: {
    async remoteMethod(query) {
      this.loading = true
      const [err, res] = await planTaskApi.getList({
        keyWords: query,
        skipCount: 0,
        maxResultCount: 9999,
      })
      if (!err) {
        this.scheduleList = res.items.filter((o) => {
          return o.id !== this.currentItemProps?.data?.id
        })
      }
      this.loading = false
    },
    close() {
      this.$emit('close')
    },
    dateChange() {
      this.modelForm.dateRange = [...this.dateRange]
    },
    async submit() {
      await this.$refs.modelFormRef.validate()

      const body = {
        ...this.modelForm,
        planStartDt: this.dateRange?.[0],
        planCompleteDt: this.dateRange?.[1],
      }
      delete this.modelForm.dateRange
      const [err, res] = await planTaskApi.update(this.modelForm.id, { body })
      if (!err) {
        this.$message.success('编辑成功')
        this.close()
      }
    },
    async getInfo() {
      const [err, res] = await planTaskApi.get(this.currentItemProps.id)
      if (!err) {
        this.modelForm = _.cloneDeep(res)
        this.dateRange = [this.modelForm.planStartDt, this.modelForm.planCompleteDt]
        this.modelForm.dateRange = [this.modelForm.planStartDt, this.modelForm.planCompleteDt]
      }
    },
  },
  async mounted() {
    await this.getInfo()
    this.remoteMethod()
  },
}
</script>

<style>
</style>
